import { GuestsTotalCard } from '../components/GuestsTotalCard';
import { GuestsTable } from '../components/GuestsTable';

export const Guests = () => {
  return (
    <div className="flex flex-col gap-6">
      <h1 className="text-xl font-semibold text-gray-900">Members</h1>
      <GuestsTotalCard />
      <GuestsTable />
    </div>
  );
};
